import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Column } from '../Layout/Column';
import styles from './DimmedIfDisabled.module.scss';
export const DimmedIfDisabled = (param)=>{
    let { enabled, children } = param;
    return /*#__PURE__*/ _jsx(Column, {
        width: "100%",
        "aria-disabled": !enabled,
        className: cn(styles.root, {
            [styles.disabled]: !enabled
        }),
        children: children
    });
};
